// extracted by mini-css-extract-plugin
export default {"description":"style_description__6vBs6","fade-in":"style_fade-in__eCjG2","top":"style_top__YWA-N","image":"style_image__Mv2P4"};